// Grandia · home V2: tab-uri + carusel, ceasul ofertelor, „Cumpără după cameră”, adăugare în coș (inclusiv „tot setul”).
// Coșul: POST /cart/add.js, apoi CartAddEvent-ul temei → sertarul de coș se re-randează și se deschide singur.
import { CartAddEvent } from '@theme/events';

const once = (el, key) => (el.dataset[key] ? false : (el.dataset[key] = '1'));

async function addToCart(items, sourceEl) {
  const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items }),
  });
  const data = await res.json();
  if (!res.ok || data.status) throw new Error(data.description || data.message || 'Nu am putut adăuga în coș');
  const count = items.reduce((s, i) => s + (i.quantity || 1), 0);
  sourceEl.dispatchEvent(new CartAddEvent({}, String(items[0].id), { source: 'grandia-home', itemCount: count }));
  return data;
}

function bindAdd(root) {
  root.querySelectorAll('[data-gh-add]').forEach((btn) => {
    if (!once(btn, 'ghBound')) return;
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const ids = btn.dataset.ghAdd.split(',').filter(Boolean);
      if (!ids.length || btn.getAttribute('aria-busy') === 'true') return;
      const label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      try {
        await addToCart(ids.map((id) => ({ id: Number(id), quantity: 1 })), btn);
        btn.classList.add('is-done');
        btn.textContent = btn.dataset.ghDone || 'Adăugat în coș';
        setTimeout(() => { btn.classList.remove('is-done'); btn.textContent = label; }, 2500);
      } catch (err) {
        btn.textContent = err.message;
        setTimeout(() => (btn.textContent = label), 3500);
      } finally {
        btn.removeAttribute('aria-busy');
      }
    });
  });
}

function bindTabs(root) {
  root.querySelectorAll('[data-gh-tabs]').forEach((wrap) => {
    if (!once(wrap, 'ghBound')) return;
    const tabs = [...wrap.querySelectorAll('[role="tab"]')];
    const select = (t) => {
      tabs.forEach((x) => {
        const on = x === t;
        x.setAttribute('aria-selected', on);
        x.tabIndex = on ? 0 : -1;
        const p = wrap.querySelector('#' + x.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      updatePager(wrap);
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        const n = tabs[(i + d + tabs.length) % tabs.length];
        n.focus(); select(n);
      });
    });
  });
}

const activeTrack = (wrap) => [...wrap.querySelectorAll('[data-gh-track]')].find((t) => !t.closest('[hidden]'));
function updatePager(wrap) {
  const t = activeTrack(wrap), prev = wrap.querySelector('[data-gh-prev]'), next = wrap.querySelector('[data-gh-next]');
  if (!t || !prev || !next) return;
  prev.disabled = t.scrollLeft <= 2;
  next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
}
function bindPager(root) {
  root.querySelectorAll('[data-gh-carousel]').forEach((wrap) => {
    if (!once(wrap, 'ghPager')) return;
    const go = (dir) => { const t = activeTrack(wrap); if (t) t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' }); };
    wrap.querySelector('[data-gh-prev]')?.addEventListener('click', () => go(-1));
    wrap.querySelector('[data-gh-next]')?.addEventListener('click', () => go(1));
    wrap.querySelectorAll('[data-gh-track]').forEach((t) => t.addEventListener('scroll', () => updatePager(wrap), { passive: true }));
    updatePager(wrap);
  });
}

function bindCountdown(root) {
  root.querySelectorAll('[data-gh-cd]').forEach((el) => {
    if (!once(el, 'ghBound')) return;
    const fixed = el.dataset.ghEnd ? new Date(el.dataset.ghEnd) : null;
    const parts = { h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
    const tick = () => {
      const now = new Date();
      let end = fixed && fixed > now ? fixed : new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      let s = Math.max(0, Math.floor((end - now) / 1000));
      const h = Math.floor(s / 3600);
      parts.h.textContent = String(h).padStart(2, '0');
      parts.m.textContent = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
      parts.s.textContent = String(s % 60).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  });
}

function bindRooms(root) {
  root.querySelectorAll('[data-gh-room]').forEach((room) => {
    if (!once(room, 'ghBound')) return;
    const set = (i) => {
      room.querySelectorAll('[data-hot]').forEach((h) => h.setAttribute('aria-expanded', h.dataset.hot === i));
      room.querySelectorAll('[data-pop]').forEach((p) => p.classList.toggle('is-on', p.dataset.pop === i));
      room.querySelectorAll('[data-ri]').forEach((r) => r.classList.toggle('is-on', r.dataset.ri === i));
    };
    room.querySelectorAll('[data-hot]').forEach((h) => h.addEventListener('click', () => set(h.getAttribute('aria-expanded') === 'true' ? '' : h.dataset.hot)));
    room.querySelectorAll('[data-ri]').forEach((r) => r.addEventListener('mouseenter', () => set(r.dataset.ri)));
  });
}

function init(root = document) { bindAdd(root); bindTabs(root); bindPager(root); bindCountdown(root); bindRooms(root); }
init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
document.addEventListener('grandia:cards', (e) => init(e.target));
